import {Injectable} from '@angular/core';
import {WidgetTemplate} from '../../features/widgets/models/widget-template';
import {Widget} from '../../features/widgets/models/widget';

@Injectable({
  providedIn: 'root',
})
export class DashboardManagementService {

  syncEnabledStatus(widgetTemplates: WidgetTemplate[], enabledWidgets: Widget[]): WidgetTemplate[] {
    // Start by clearing the flag for all templates
    widgetTemplates.forEach((widgetTemplate: WidgetTemplate) => {
      widgetTemplate.enabled = false;
    })
    // Set the flag to true for all template that have corresponding widgets in the enabledWidgets array
    enabledWidgets.forEach((widget: Widget) => {
      const enabledWidgetTemplate = widgetTemplates.find((widgetTemplate: WidgetTemplate) => widgetTemplate.key === widget.widgetKey);
      if (enabledWidgetTemplate) {
        enabledWidgetTemplate.enabled = true;
      }
    })
    return widgetTemplates;
  }


  updateEnabledWidgets(widgetTemplates: WidgetTemplate[], enabledWidgets: Widget[]): {enabledWidgets: Widget[], removedWidgets: Widget[]} | undefined {
    let listUpdated = false;
    const removedWidgets: Widget[] = [];
    widgetTemplates.forEach((widgetTemplate: WidgetTemplate) => {
      // Get the index of the widgetTemplate in the enabledWidgets array.
      const widgetIndex = enabledWidgets.findIndex((widget: Widget) => widget.widgetKey === widgetTemplate.key);

      // Widget has been disabled
      if (widgetIndex > -1 && !widgetTemplate.enabled) {
        const updatedList: Widget[] = [];

        // Ugly logic, because array.splice() seems to fail when trying to remove the last item.
        enabledWidgets.forEach((widget: Widget, index: number) => {
          if (index !== widgetIndex) {
            updatedList.push(widget);
          } else {
            removedWidgets.push(widget);
          }
        })
        enabledWidgets = updatedList;
        listUpdated = true;
      }

      // New widget has been enabled
      else if (widgetIndex === -1 && widgetTemplate.enabled) {
        enabledWidgets.push(this.createWidgetFromTemplate(widgetTemplate));
        // We need to update the actual array reference, not just the content, otherwise the @Input of the Grid
        // Component doesn't get triggered.
        enabledWidgets = [...enabledWidgets];
        listUpdated = true;
      }
    });
    //
    // // If changes were made, persist them to tbe backend.
    if (listUpdated) {
      return {enabledWidgets, removedWidgets};
    } else {
      return undefined;
    }
  }

  private createWidgetFromTemplate(widgetTemplate: WidgetTemplate): Widget {
    return {
      widgetKey: widgetTemplate.key,
      widgetName: widgetTemplate.widgetTemplateName,
      title: widgetTemplate.title,
      widgetType: widgetTemplate.widgetType,
      showHeader: widgetTemplate.showHeader,
      showFooter: widgetTemplate.showFooter,
      enabled: widgetTemplate.enabled,
      defaultWidth: widgetTemplate.defaultWidth,
      defaultHeight: widgetTemplate.defaultHeight,
      tables: [...(widgetTemplate.tables ?? [])]
        .sort((a, b) => a.orderIndex - b.orderIndex)
    } as Widget;
  }

}
